import * as THREE from 'three'

// The single source of truth for render-parity settings. Both the authoring
// app and any importer must drive these identical values, or A's export and
// B's import diverge. The exporter copies RENDER_DEFAULTS into the package
// manifest; the loader reads the manifest back and applies it here.
export const RENDER_DEFAULTS = {
  three: '>=0.150',
  spark: '2.1.0',
  toneMapping: 'ACESFilmic',
  toneMappingExposure: 1.0,
  outputColorSpace: 'srgb',
  pmrem: true,
}

const TONE_MAPPING = {
  ACESFilmic: THREE.ACESFilmicToneMapping,
  Linear: THREE.LinearToneMapping,
  Reinhard: THREE.ReinhardToneMapping,
  None: THREE.NoToneMapping,
}

const COLOR_SPACE = {
  srgb: THREE.SRGBColorSpace,
  'srgb-linear': THREE.LinearSRGBColorSpace,
}

// Applies the manifest's render block to a live WebGLRenderer.
export function applyRenderConfig(renderer, render = {}) {
  const tm = TONE_MAPPING[render.toneMapping] ?? THREE.ACESFilmicToneMapping
  const cs = COLOR_SPACE[render.outputColorSpace] ?? THREE.SRGBColorSpace
  renderer.toneMapping = tm
  renderer.toneMappingExposure = render.toneMappingExposure ?? 1.0
  renderer.outputColorSpace = cs
}
